import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function parseAnnotationString(annotation: string): {
    page: number;
    left: number;
    top: number;
    width: number;
    height: number;
}[] {
    const annotations = annotation.split(';');

    return annotations.map(a => {
        if (a.startsWith('bbox:')) {
            const parts = a.slice(5).split(',');
            return {
                page: parseInt(parts[0] ?? '', 10),
                left: parseFloat(parts[1] ?? ''),
                top: parseFloat(parts[2] ?? ''),
                width: parseFloat(parts[3] ?? ''),
                height: parseFloat(parts[4] ?? ''),
            };
        }

        // Assume default is a "page annotation" (e.g. page:1)
        const parts = a.split(':');
        return {
            page: parseInt(parts[1] ?? '', 10),
            left: 0,
            top: 0,
            width: 100,
            height: 100,
        };
    });
}
